import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from "../../../../ui/dialog";
import { EDSButton } from "../../../../eds/EDSButton";
import { Input } from "../../../../ui/input";
import { Label } from "../../../../ui/label";

interface LinkBookingDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (reference: string) => void;
  isLinking: boolean;
}

const LinkBookingDialog = ({
  open,
  onOpenChange,
  onConfirm,
  isLinking
}: LinkBookingDialogProps) => {
  const [reference, setReference] = useState("");

  const handleConfirm = () => {
    const trimmedRef = reference.trim();
    if (!trimmedRef) return;
    onConfirm(trimmedRef);
  };

  const handleOpenChange = (nextOpen: boolean) => {
    if (!nextOpen) {
      setReference("");
    }
    onOpenChange(nextOpen);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && reference.trim()) {
      handleConfirm();
    }
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent
        showCloseButton={false}
        aria-describedby="link-booking-dialog-description"
        className="bg-[var(--panelBackground)] shadow-[0_3px_16px_0_rgba(0,0,0,0.16)] max-w-[400px] w-[90%]"
      >
        <DialogHeader>
          <DialogTitle>Link booking</DialogTitle>
          <DialogDescription id="link-booking-dialog-description">
            Enter the booking reference number to link it to this booking.
          </DialogDescription>
        </DialogHeader>

        <div className="py-2">
          <Label
            htmlFor="link-booking-reference"
            className="text-sm font-medium"
          >
            Booking reference
          </Label>
          <div className="mt-2 flex items-center gap-1">
            <span className="text-sm font-medium shrink-0">DMN-</span>
            <Input
              id="link-booking-reference"
              type="text"
              inputMode="numeric"
              value={reference}
              onChange={(e) => setReference(e.target.value.replace(/\D/g, ""))}
              onKeyDown={handleKeyDown}
              placeholder="e.g. 123456"
              disabled={isLinking}
              autoFocus
            />
          </div>
        </div>

        <DialogFooter>
          <EDSButton
            variant="outline"
            size="md"
            onClick={() => handleOpenChange(false)}
            disabled={isLinking}
          >
            Cancel
          </EDSButton>
          <EDSButton
            variant="default"
            size="md"
            onClick={handleConfirm}
            disabled={isLinking || !reference.trim()}
            aria-busy={isLinking}
          >
            {isLinking ? "Linking…" : "Link"}
          </EDSButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default LinkBookingDialog;
